import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import ReactModal from 'react-modal'
import USD from './usd'
import { ajaxGet, ajaxPost } from '../ajax'

function BraintreePaymentModal(props) {
  const state = useRef({storeCardCalled: false})
  const storeCard = useRef()

  useEffect(() => {
    if (!props.isOpen) return

    fetch('/admins/payment/get_token', {credentials: 'include'})
    .then(response => response.json())
    .then(json => {
      if (json.braintree_token === 'fake_client_token') return

      braintree.setup(json.braintree_token, 'dropin', {
        container: 'braintreeContainer',
        onPaymentMethodReceived: paymentMethod => {
          if (state.current.storeCardCalled) storeCardWebservice(paymentMethod.nonce)
          else props.onPaymentMethodReceived({
            type: 'card_number', token: paymentMethod.nonce, store_card: storeCard.current.checked
          })
        },
        onError: e => console.log('braintree setup error: ' + e)
      })
    })
  }, [props.isOpen])

  const storeCardWebservice = token => {
    const data = {
      reservation_id: props.reservationId,
      player_id: props.playerId,
      id: props.id,
      token: token
    }

    ajaxPost('/admins/payment/store_card', data)
    .then(response => response.json())
    .then(json => { 
      if (json.error) console.log('store card error: ' + json.error)
      else {
        props.onRequestClose()
        props.onCardsUpdate(json.cards)
      }
    })
  }

  return (
    <ReactModal isOpen={props.isOpen}
      onRequestClose={props.onRequestClose} contentLabel='Payment Modal'>
      <div className='shop-manual-payment panel panel-default'>
        <div className='panel-heading'>Create Transaction</div>
        <div className='panel-body'>
          <form id='paymentForm'>
            <div id='braintreeContainer' className='braintree-payment-form'></div>
            <br/>
            <div className='checkbox'>
              <label>
                <input type='checkbox' ref={storeCard} /> Store Card
              </label>
            </div>
            <div className='col-md-12 text-center'> 
              <button className='btn btn-success pull-left' type='submit'>
                Pay <USD val={props.amount}/>
              </button>
              <button className='btn btn-primary' type='submit' onClick={e => {state.current = {storeCardCalled: true}}}>
                Store Card
              </button>
              <button className='btn btn-info pull-right'
                onClick={e => {e.preventDefault(); props.onRequestClose()}}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </ReactModal>
  )
}

BraintreePaymentModal.propTypes = {
  amount: PropTypes.number.isRequired,
  isOpen: PropTypes.bool,
  onPaymentMethodReceived: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  onCardsUpdate: PropTypes.func.isRequired
}

export default BraintreePaymentModal
